<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px" size="small">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="querySearch()"></el-input>
          </el-form-item>
          <el-form-item label="SKU：">
            <el-input size="medium" v-model="searchForm.sku" @keyup.enter.native="querySearch()"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" @click="finishEntry()" style="margin-top:20px;float:right">录入完成</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="产品品牌" prop="BRAND"></el-table-column>
          <el-table-column label="单价" prop="CURRENT_PRICE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="addProduct(scope.row)">新增</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" size="small">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ this.addForm.NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.addForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：" :label-width="formLabelWidth">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input v-model="addForm.CURRENT_PRICE"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input v-model="addForm.count"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input v-model="addForm.comment" maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { chooseEntryFun, finishFun, addOrderListFun } from 'api/shopOrderManage';
import util from '../../assets/common/util';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      loading: false,
      loading1: false,
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  methods: {
    // ---------------------------------------筛选功能
    querySearch() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      if (this.searchForm.sku) {
        params.PRODUCT_CODE = parseInt(this.searchForm.sku);
      }
      this.loading = true;
      chooseEntryFun(params)
        .then((result) => {
          if (result[0].list.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.querySearch();
    },
    addProduct(row) {
      this.addFormVisible = true;
      this.addForm = row;
      this.addForm.nowPrice = row.CURRENT_PRICE;
    },
    close() {
      this.addFormVisible = false;
      this.querySearch();
    },
    // ----------------------------------------新增产品功能
    submitAdd() {
      this.addOrderProduct();
    },
    addOrderProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // let reg = /\d/
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.addForm.CURRENT_PRICE) || this.addForm.CURRENT_PRICE <= 0) {
            this.$message.show({ text: '请输入正数单价', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!reg.test(this.addForm.count) || this.addForm.count <= 0) {
            this.$message.show({ text: '请输入订购数量', type: 'error' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
            const beInter = (this.addForm.count % 1 === 0);
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
              document.body.style.cursor = 'default';
              return false;
            }
          } else {
            document.body.style.cursor = 'default';
          }
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
            TP_ID: this.addForm.ID,
            PRODUCT_COUNT: Number(this.addForm.count),
          };
          if (this.addForm.CURRENT_PRICE) {
            params.PRICE = this.addForm.CURRENT_PRICE;
          }
          if (this.addForm.comment) {
            params.PRODUCT_COMMENT = this.addForm.comment;
          }
          addOrderListFun(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.querySearch();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    finishEntry() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: sessionStorage.getItem('orderId'),
            ORDER_CODE: sessionStorage.getItem('orderCode'),
          };
          finishFun(params).then((result) => {
            this.$router.push({ name: 's_addOrder' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_addProduct.vue